import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from 'js-cookie'
import axiosInstance from "../../Component/axiosInstance";


const addGraphSection = createAsyncThunk('display', async (sectordata, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/graph/storegraphdata`,sectordata, {
            headers: {
                'x-auth-token': localStorage.getItem('token'),                 
            }
        });

        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});


const addGraphSectionSlice = createSlice({
    name: 'addGraphSection',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addGraphSection.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(addGraphSection.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(addGraphSection.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;  // Fixed issue here
                state.isSuccess = false;
            });
    }
})


export { addGraphSection };
export default addGraphSectionSlice.reducer;